const ULTIMATE_PACK_PLAN_CODES: readonly string[] = [
  "lpr_ultimate_pack_otp",
  "lpr_astr_ultimate_pack_otp",
  "lpr_aos_ultimate_pack_otp",
  "lpr_ultimate_pack_sale_otp",
  "lpr_astr_ultimate_pack_sale_otp",
  "lpr_aos_ultimate_pack_sale_otp",
]

/**
 * Plan code that unlocks the Astrology report (one-time). The backend report
 * list (`byType(id).planId`) is the source of truth; this is the client-side
 * fallback used until that list has loaded (report modals v1/v2).
 */
export const STAR_REPORT_SUBSCRIPTION_PLAN_ID = "lpr_astrology_report_2899"

/** Report promo modal v1 offer. */
export const STAR_REPORT_MODAL_V1_PLAN_ID = "lpr_astrology_report_999"

/** Report promo modal v2 offer. */
export const STAR_REPORT_MODAL_V2_PLAN_ID = "lpr_astrology_report_699"

/** Ported from lpr-web `STAR_REPORT_SUBSCRIPTION_PLAN_ID_ASTROLOGIA`. */
export const STAR_REPORT_SUBSCRIPTION_PLAN_ID_ASTROLOGIA = "lpr_astr_pdf_report"

/**
 * Plan codes that unlock the Astrology report.
 * Ported from lpr-web `STAR_REPORT_SUBSCRIPTION_PLAN_IDS`.
 */
export const STAR_REPORT_PLAN_CODES: readonly string[] = [
  ...ULTIMATE_PACK_PLAN_CODES,
  STAR_REPORT_SUBSCRIPTION_PLAN_ID,
  STAR_REPORT_MODAL_V1_PLAN_ID,
  STAR_REPORT_MODAL_V2_PLAN_ID,
  STAR_REPORT_SUBSCRIPTION_PLAN_ID_ASTROLOGIA,
  "lpr_pdf_report",
  "lpr_aos_pdf_report",
  "lpr_aos_pdf_report_sale_otp",
  "lpr_astr_pdf_report_sale_otp",
  "lpr_pdf_report_sale_otp",
  "lpr_astr_pdf_report_sale2_otp",
  "lpr_pdf_report_sale2_otp",
  "lpr_aos_pdf_report_sale2_otp",
]

/**
 * Plan code that unlocks the Love Match / Compatibility report (one-time).
 * The backend report list (`byType(id).planId`) is the source of truth; this
 * is the client-side fallback used until that list has loaded (report modals v1/v2).
 */
export const TRUTHS_REPORT_SUBSCRIPTION_PLAN_ID = "lpr_compatibility_report_2899"

/** Report promo modal v1 offer. */
export const TRUTHS_REPORT_MODAL_V1_PLAN_ID = "lpr_love_match_report_999"

/** Report promo modal v2 offer. */
export const TRUTHS_REPORT_MODAL_V2_PLAN_ID = "lpr_love_match_report_699"

/** Ported from lpr-web `TRUTHS_REPORT_SUBSCRIPTION_PLAN_ID_ASTROLOGIA`. */
export const TRUTHS_REPORT_SUBSCRIPTION_PLAN_ID_ASTROLOGIA = "lpr_astr_rel_report_otp"

/**
 * Plan codes that unlock the Love Match report.
 * Ported from lpr-web `TRUTHS_REPORT_SUBSCRIPTION_PLAN_IDS`.
 */
export const TRUTHS_REPORT_PLAN_CODES: readonly string[] = [
  TRUTHS_REPORT_SUBSCRIPTION_PLAN_ID,
  TRUTHS_REPORT_MODAL_V1_PLAN_ID,
  TRUTHS_REPORT_MODAL_V2_PLAN_ID,
  TRUTHS_REPORT_SUBSCRIPTION_PLAN_ID_ASTROLOGIA,
  ...ULTIMATE_PACK_PLAN_CODES,
  "lpr_rel_report_otp",
  "lpr_aos_rel_report_otp",
  "lpr_aos_rel_report_sale_otp",
  "lpr_astr_rel_report_sale_otp",
  "lpr_rel_report_sale_otp",
  "lpr_astr_rel_report_sale2_otp",
  "lpr_rel_report_sale2_otp",
  "lpr_aos_rel_report_sale2_otp",
]

/**
 * Plan code that unlocks the Soulmate Sketch report (one-time). The backend
 * report list (`byType(id).planId`) is the source of truth; this is the
 * client-side fallback used until that list has loaded.
 */
export const SOULMATE_REPORT_SUBSCRIPTION_PLAN_ID = "lpr_soulmate_sketch_report_2899"

/** Report promo modal v1 offer. */
export const SOULMATE_REPORT_MODAL_V1_PLAN_ID = "lpr_soulmate_sketch_999"

/** Report promo modal v2 offer. */
export const SOULMATE_REPORT_MODAL_V2_PLAN_ID = "lpr_soulmate_sketch_699"

/**
 * Main subscription plans that include the Soulmate Sketch report.
 */
export const SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_SOULMATE_REPORT: readonly string[] = [
  "lpr_3d499_1m4999_ss",
]

/**
 * Plan codes that unlock the Soulmate Sketch report (OTP + main plans that
 * include it). Used for in-app entitlement before `GET /v1/reports/me` loads.
 */
export const SOULMATE_REPORT_PLAN_CODES: readonly string[] = [
  SOULMATE_REPORT_SUBSCRIPTION_PLAN_ID,
  SOULMATE_REPORT_MODAL_V1_PLAN_ID,
  SOULMATE_REPORT_MODAL_V2_PLAN_ID,
  ...SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_SOULMATE_REPORT,
]

/**
 * Plan code that unlocks the Astro Map report (one-time). The backend report list
 * (`byType(id).planId`) is the source of truth; this is the client-side fallback.
 */
export const ASTRO_MAP_REPORT_SUBSCRIPTION_PLAN_ID = "lpr_astro_map_report_2899"

/** Report promo modal v1 offer. */
export const ASTRO_MAP_REPORT_MODAL_V1_PLAN_ID = "lpr_astro_map_999"

/** Report promo modal v2 offer. */
export const ASTRO_MAP_REPORT_MODAL_V2_PLAN_ID = "lpr_astro_map_699"

/**
 * Main subscription plans that include the Astro Map report.
 */
export const SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_ASTRO_MAP_REPORT: readonly string[] = [
  "lpr_3d499_1m4999_am",
]

/**
 * Plan codes that unlock the Astro Map report (OTP + main plans that include it).
 * Used for in-app entitlement before `GET /v1/reports/me` loads.
 */
export const ASTRO_MAP_REPORT_PLAN_CODES: readonly string[] = [
  ASTRO_MAP_REPORT_SUBSCRIPTION_PLAN_ID,
  ASTRO_MAP_REPORT_MODAL_V1_PLAN_ID,
  ASTRO_MAP_REPORT_MODAL_V2_PLAN_ID,
  ...SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_ASTRO_MAP_REPORT,
]

/**
 * Plan code that unlocks the Aura Scan report (one-time). The backend report list
 * (`byType(id).planId`) is the source of truth; this is the client-side fallback.
 */
export const AURA_SCAN_REPORT_SUBSCRIPTION_PLAN_ID = "lpr_aura_scan_report_2899"

/** Report promo modal v1 offer. */
export const AURA_SCAN_REPORT_MODAL_V1_PLAN_ID = "lpr_aura_scan_999"

/** Report promo modal v2 offer. */
export const AURA_SCAN_REPORT_MODAL_V2_PLAN_ID = "lpr_aura_scan_699"

/**
 * Main subscription plans that include the Aura Scan report (top + bottom
 * checkout blocks).
 */
export const SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_AURA_SCAN_REPORT: readonly string[] = [
  "lpr_3d499_1m4999_as",
]

/**
 * Plan codes that unlock the Aura Scan report (OTP + main plans that include it).
 * Used for in-app entitlement before `GET /v1/reports/me` loads.
 */
export const AURA_SCAN_REPORT_PLAN_CODES: readonly string[] = [
  AURA_SCAN_REPORT_SUBSCRIPTION_PLAN_ID,
  AURA_SCAN_REPORT_MODAL_V1_PLAN_ID,
  AURA_SCAN_REPORT_MODAL_V2_PLAN_ID,
  ...SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_AURA_SCAN_REPORT,
]

/** Passed to `/getPdfReportV2`. Ported from lpr-web `NEXT_PUBLIC_SUBSCRIPTION_ENVIRONMENT`. */
export const SUBSCRIPTION_ENVIRONMENT = "prod"
